import { render, staticRenderFns } from "./add.vue?vue&type=template&id=44f2841a&scoped=true"
import script from "./add.vue?vue&type=script&lang=ts"
export * from "./add.vue?vue&type=script&lang=ts"
import style0 from "./add.vue?vue&type=style&index=0&id=44f2841a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f2841a",
  null
  
)

export default component.exports